"use client";

import React from "react";
import { Phone, Mail, MapPin, Loader2 } from "lucide-react";
import { Link } from "@/components/common/Link";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Table, TableBody, TableCell, TableRow } from "@/components/ui/table";
import { Button } from "@/components/ui/button";
const CONTACT_LINKS = [{
  id: "phone",
  value: "+90 (212) 555 0123",
  href: "tel:+902125550123",
  icon: Phone
}, {
  id: "email",
  value: "randevu@dentalsmile.com",
  href: "mailto:randevu@dentalsmile.com",
  icon: Mail
}];
const BUSINESS_HOURS = [{
  id: "wk",
  days: "Pazartesi - Cuma",
  hours: "09:00 - 19:00"
}, {
  id: "sat",
  days: "Cumartesi",
  hours: "10:00 - 15:00"
}, {
  id: "sun",
  days: "Pazar",
  hours: "Kapalı"
}];
function ContactForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div data-section-id="178099" className="flex flex-col items-center justify-center p-8 bg-primary/5 border border-primary/20 rounded-none text-center h-full min-h-[400px]">
        <div className="size-16 bg-primary/10 rounded-full flex items-center justify-center mb-6">
          <Mail className="size-8 text-primary" />
        </div>
        <h3 className="text-2xl font-serif font-bold text-foreground mb-2">Mesajınız İletildi!</h3>
        <p className="text-muted-foreground mb-8">{successMessage}</p>
        <Button onClick={resetForm} variant="outline" className="rounded-none border-primary text-primary hover:bg-primary/5 transition-all duration-700">
          Yeni Mesaj Gönder
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <FormField control={control} name="firstName" rules={{
        required: "Ad gereklidir"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-primary font-sans font-semibold tracking-wider text-xs uppercase">Adınız</FormLabel>
              <FormControl>
                <input {...field} className="flex h-12 w-full rounded-none border-0 border-b border-primary/30 bg-transparent px-0 py-2 text-base text-foreground placeholder:text-muted-foreground/40 focus-visible:outline-none focus-visible:border-primary transition-all duration-500" placeholder="Ahmet" />
              </FormControl>
              <FormMessage />
            </FormItem>} />
        <FormField control={control} name="lastName" rules={{
        required: "Soyad gereklidir"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-primary font-sans font-semibold tracking-wider text-xs uppercase">Soyadınız</FormLabel>
              <FormControl>
                <input {...field} className="flex h-12 w-full rounded-none border-0 border-b border-primary/30 bg-transparent px-0 py-2 text-base text-foreground placeholder:text-muted-foreground/40 focus-visible:outline-none focus-visible:border-primary transition-all duration-500" placeholder="Yılmaz" />
              </FormControl>
              <FormMessage />
            </FormItem>} />
      </div>

      <FormField control={control} name="email" rules={{
      required: "E-posta gereklidir",
      pattern: {
        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        message: "Geçerli bir e-posta adresi giriniz"
      }
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className="text-primary font-sans font-semibold tracking-wider text-xs uppercase">E-posta Adresi</FormLabel>
            <FormControl>
              <input {...field} type="email" className="flex h-12 w-full rounded-none border-0 border-b border-primary/30 bg-transparent px-0 py-2 text-base text-foreground placeholder:text-muted-foreground/40 focus-visible:outline-none focus-visible:border-primary transition-all duration-500" placeholder="ahmet@email.com" />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <FormField control={control} name="message" rules={{
      required: "Mesaj gereklidir",
      minLength: {
        value: 10,
        message: "Mesaj en az 10 karakter olmalıdır"
      }
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className="text-primary font-sans font-semibold tracking-wider text-xs uppercase">Nasıl yardımcı olabiliriz?</FormLabel>
            <FormControl>
              <textarea {...field} className="flex min-h-[160px] w-full rounded-none border-0 border-b border-primary/30 bg-transparent px-0 py-3 text-base text-foreground placeholder:text-muted-foreground/40 focus-visible:outline-none focus-visible:border-primary transition-all duration-500 resize-none" placeholder="Tedavi talebiniz veya sorularınız..." />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      {submitError && <div className="p-4 bg-destructive/10 border border-destructive/20 rounded-none">
          <p className="text-destructive text-sm font-medium">{submitError}</p>
        </div>}

      <Button type="submit" disabled={isSubmitting} className="w-full h-14 text-lg font-serif font-bold rounded-none bg-primary text-primary-foreground hover:bg-primary/90 shadow-none transition-all duration-700 tracking-widest uppercase">
        {isSubmitting ? <>
            <Loader2 className="animate-spin mr-2 size-5" />
            Gönderiliyor...
          </> : "Randevu Talebi Gönder"}
      </Button>
    </Form>;
}
export default function ContactPageOverview() {
  return;
}